import React from "react";
import Banner from "../components/Banner/Banner";
import Header from "../../layouts/Header/Header";
import Footer from "../../layouts/Footer/Footer";

const Home = () => {
  return (
    <div>
      <Header />
      <Banner effect={"parallax"} />
      <Footer />
    </div>
  );
};

export default Home;
